/* eslint-disable */
export default {
  accountId:"kua1hm0cnkp3zjalpl2i",
  channelId:"y1id4pm3ainxdbkumnrs",
  channelFilter: function() { return true },
  staticChannels: [
    {id:"z7my6siwcic8i5aazbms",name:"Alfred State",abbrev:"as",accountId:"ol1uwnqkqz6u59phtpxk"},
    {id:"osgxjjvazifuu2blsgd6",name:"Carlow University",abbrev:"cu",accountId:"z8hmxk2qjpachci7ypb7"},
    {id:"pJlxdzXGPrf8SAfA5uFG",name:"Hilbert College",abbrev:"hc",accountId:"	HILBERTC"},
    {id:"ypk6tsi58cmbcamwrhil",name:"La Roche University",abbrev:"lru",accountId:"vezbox77kfhbu283cdkj"},
/*  {id:"EpnUXhGIZpb8U7LrS1Y8",name:"Medaille College",abbrev:"mc",accountId:"MEDAILLE"},*/    
    {id:"HpWrjsG3hDHBlMvne5eS",name:"Mount Aloysius",abbrev:"ma",accountId:"ALOYSIUS"},
    {id:"3GV4dNaHfVUvI2vcsu0O",name:"Penn State Behrend",abbrev:"psb",accountId:"PENNBEHR"},
    {id:"ulcybhqbnihuu5rf8gt6",name:"Penn State Altoona",abbrev:"psa",accountId:"tninmplojeo4ebchqflp"},
    {id:"Gsf35yCZ33iF3B9G2odS",name:"Pitt Bradford",abbrev:"pb",accountId:"PITTBRAD"},
    {id:"0GDwB3QA6uGFKbvCBK68",name:"Pitt Greensburg",abbrev:"pg",accountId:"PITTGRNS"},
    {id:"uavwpuiulrddsb2ivfef",name:"Wells College",abbrev:"wc",accountId:"iymqo8u9ggcsfailhtit"},
    {id:"fdo0g2fdnrkdlv1c2nxb",name:"AMCC TV",abbrev:"amcc",accountId:"mgfdzr3u4zen0i1lsayj"},
  ]
}



// WEBPACK FOOTER //
// ./src/config.js